import queryString from 'query-string'
import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import agent from 'agent'
import BusyOverlay from 'components/common/BusyOverlay'
import useAuth from 'hooks/use-auth'
import toast from 'lib/toast'
import { messageFromResponseError } from 'utils/strings'

export const SAML: React.FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const authState = useAuth()

  const handleError = (err) => {
    toast({
      type: 'error',
      text: messageFromResponseError(
        err,
        'Unable to authenticate using SAML. Please try again later.'
      )
    })

    navigate('/')
  }

  const runAuth = async () => {
    const { SamlSessionCode, RelayState } = queryString.parse(location.search)

    if (!SamlSessionCode.length || !RelayState.length) {
      handleError('parse-error')
      return
    }

    try {
      const res = await agent.post('/users/auth/saml/sessions', {
        code: SamlSessionCode
      })
      await authState.startSession(res.data)
      navigate(Array.isArray(RelayState) ? RelayState[0] : RelayState)
    } catch (err) {
      return handleError(err)
    }
  }

  useEffect(() => {
    runAuth()
  })

  return <BusyOverlay shown={true} text="Authorizing" />
}
